<template>
    <div class="accolades-collection" v-if="show">
        <div class="flex-y-center" @click="MobileToggle()">
            <h2>{{ collectionNameHeading }}</h2>
            <img class="expand-indicator flex-right" :src="expandIndicatorSource.source" :alt="`Icon - ${expandIndicatorSource.name}`" :title="expandIndicatorSource.name" width="30" height="30" v-if="mobile"/>
        </div>
        <div v-for="(accoladeGroup, a) in accolades.Group" :key="a">
            <div v-if="!mobile || (mobile && showAccolades)">
                <h3 v-if="ShowSubHeader(accoladeGroup.SubType)">{{ accoladeGroup.SubType }}</h3>
                <div class="accolades flex flex-wrap">
                    <div class="accolade flex-bottom m-row" v-for="(accolade, aa) in accoladeGroup.Accolades" :key="aa">
                        <div class="flex">
                            <Accolade
                                :accolade="accolade"
                                :mobile="platform.mobile"
                                :collection="collectionName"
                                @last-viewed-top-position="$emit('last-viewed-top-position', $event)"
                            />
                            <div :class="['divider m-hide', DividerState(aa, accoladeGroup)]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Accolade from "@/components/Accolades/Accolade.vue";
import { viewModel } from "@/models";
import { MASTER } from "@/assets/JS/Master.js";
import { ASSETS } from "@/assets/JS/Assets.js";

export default {
    name: "AccoladesCollection",
    props: {
        accolades: Object,
        collectionName: String,
        show: Boolean,
        mobile: Boolean
    },
    components: { Accolade },
    data: () => ({
        ...viewModel.data,
        collectionNameHeading: "",
        showAccolades: false,
        expandIndicatorSource: {
            source: "",
            name: ""
        }
    }),
    methods: {
        DividerState: function(accoladeIndex, accolades) {
            const show = ((accoladeIndex + 1) % 5 !== 0) && accoladeIndex < accolades.Accolades.length - 1;
            return show ? "" : "no-divider";
        },
        ShowSubHeader: function(heading) {
            return this.accolades.Group.length > 1 && heading !== "Other";
        },
        AccoladeCounts: function() {
            this.$emit("collection-counts", {
                collection: this.collectionNameHeading,
                counts: this.accolades.Total
            });
        },
        MobileToggle: function() {
            if (this.platform.mobile) {
                this.showAccolades = !this.showAccolades;
                this.ExpandIndicatorSource();
            }
        },
        ExpandIndicatorSource: function() {
            const expandIndicatorSource = !this.showAccolades ? "PlusWhite.png" : "MinusWhite.png";
            const expandIndicatorName = !this.showAccolades ? "Plus" : "Minus";
            this.expandIndicatorSource = {
                source: require(`@/assets/Images/${expandIndicatorSource}`),
                name: expandIndicatorName
            }
        }
    },
    beforeMount: function() {
        this.collectionNameHeading = ASSETS.CustomAccoladeName(this.collectionName);
        this.AccoladeCounts();
        if (this.platform.mobile && this.collectionName === "Features") {
            this.showAccolades = true;
        }
        this.ExpandIndicatorSource();
    },
    mounted: function() { this.platform.mobile = MASTER.Platform._mobile; },
    emits: [
        "collection-counts",
        "last-viewed-top-position"
    ]
};
</script>